module.exports = __webpack_public_path__ + "img/conet_dark.6ebde19.png";